export class ListTableContextVersionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "versions",
            "baseName": "versions",
            "type": "Array<TableContextVersion>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableContextVersionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
